import { Component, Input, OnInit } from '@angular/core';

import { GenericModal } from '../modals/generic-modal/generic-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { ComponentService } from '../../services/component.service';
import { PracticeService } from '../../services/practice.service';
import { StateService } from '../../services/state.service';
import { LibService } from '../../services/libService';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';



@Component({
  selector: 'app-planning-button-restore-previuous-state',
  templateUrl: './planning-button-restore-previuous-state.component.html',
  styleUrls: ['./planning-button-restore-previuous-state.component.scss']
})
export class PlanningButtonRestorePreviuousStateComponent implements OnInit {

  @Input() practice: any;
  @Input() element: any;

  components: any;
  attributes: any;
  componentName: any = 'planningRestorePreviousState'
  objectStructure: any = {}
  settings: any = {}


  constructor(
    private dialog: MatDialog,
    private componentService: ComponentService,
    private libService: LibService,
    private practiceService: PracticeService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private stateService: StateService,
  ) { }

  ngOnInit(): void {
    console.log('ngOnInit Planning Button Component')
  }


  setAttributes() {
    //console.log('setAttributes')
    let component = this.components?.settings?.find((component: any) => component.componentCode == this.componentName)
    this.attributes = component?.attributes
    if (this.attributes) this.objectStructure = this.componentService.getObjectStructure(this.attributes)
  }

  getState(stateId: any) {

    if (stateId) {
      this.stateService.getState(stateId).subscribe((response: any) => {
        this.setComponents(response.components)
        this.setAttributes()
        this.getSettings()
        this.openModal(this.settings)
        this.libService.unlockPage();
      })
    } else {
      this.setComponents(null)
      this.setAttributes()
    }
  }

  getSettings() {
    let code = 'restorePreviousState'
    this.settings.titleLabel = 'CHANGESTATEBUTTON.' + code + '_title',
      this.settings.textLabel = 'CHANGESTATEBUTTON.' + code + '_text'
  }

  setComponents(components: any) {
    //console.log('setComponents')
    this.components = { codes: [], settings: [] }
    if (components != null) {
      Object.keys(components).forEach(key => {
        let tmpComponent = {
          componentCode: key,
          attributes: components[key]?.attributes
        }
        this.components.codes.push(key)
        this.components.settings.push(tmpComponent)
      });
    }
  }

  openModalForNonProgrammable(e: any, OrderId: any) {

    // Ottieni i component della pratica
    console.log(e)

    let code = e.CodicePratica
    this.libService.lockPage('');
    this.practiceService.showByAttributes({ code: code }).subscribe((response: any) => {
      this.practice = response
      this.getState(response.StateId)
    })

  }

  openModal(settings: any) {
    console.log(settings)
    const dialogRef = this.dialog.open(GenericModal, {
      width: '600px',
      data: settings
    });

    dialogRef.afterClosed().subscribe(result => {

      if (![null, undefined].includes(result)) {
        let attributes = result;
        attributes.componentName = this.componentName
        this.libService.lockPage('');
        this.practiceService.restorePreviousState(this.practice.id).subscribe(
          ret => {
            this.toastr.success(this.translate.instant('LABEL.DATA_SUCCESS'), this.translate.instant('TOASTR.INFO'));
            this.libService.unlockPage();
            window.location.reload()
          },
          err => {
            //this.toastr.error(this.translate.instant('LABEL.Error'));
            this.libService.unlockPage();
          }
        );
      }


    });
  }


  restoreAndGoToFirstScheduling(e: any) {

    // Ottieni i component della pratica
    console.log(e)

    let code = e.CodicePratica
    this.libService.lockPage('');
    this.practiceService.showByAttributes({ code: code }).subscribe((response: any) => {
      this.practice = response
      this.getState(response.StateId)
    })

  }


}
